import './Skeleton.css';

/**
 * Animated shimmer placeholder. Drop in wherever async data lands on a
 * page so the layout doesn't jump and the coach has a sense of "loading
 * happens here" instead of staring at a blank panel.
 *
 * Brief / Sprint 5 — replaces the existing "…" text-placeholder pattern
 * scattered across pages. Hide-not-disable, but for loading: show
 * something shaped like the eventual content rather than a spinner.
 */
interface SkeletonProps {
  variant?: 'text' | 'card' | 'pill' | 'circle';
  width?: number | string;
  height?: number | string;
  /** Stack of identical skeletons — handy for list previews. */
  count?: number;
}

export function Skeleton({
  variant = 'text',
  width,
  height,
  count = 1,
}: SkeletonProps) {
  const style: React.CSSProperties = {};
  if (width !== undefined) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height !== undefined) style.height = typeof height === 'number' ? `${height}px` : height;

  if (count === 1) {
    return <span className="skeleton" data-variant={variant} style={style} aria-hidden="true" />;
  }
  return (
    <span className="skeleton-stack" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <span key={i} className="skeleton" data-variant={variant} style={style} />
      ))}
    </span>
  );
}
